import { Injectable, inject } from '@angular/core';

import { FsApi } from '@firestitch/api';

import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MentionData {
  private _api = inject(FsApi);


  public accountsPost(objectId: number, data: { mentions: any[] }): Observable<any> {
    return this._api.request('POST', `mentions/${objectId}/accounts`, data);
  }
  public objectsPost(objectId: number, data: { mentions: any[] }): Observable<any> {
    return this._api.request('POST', `mentions/${objectId}/objects`, data);
  }

}
